export const ARTISTS_DICT = Object.freeze(
    {
        "2wUjUUtkb5lvLKcGKsKqsR": {
            "external_urls": {
                "spotify": "https://open.spotify.com/artist/2wUjUUtkb5lvLKcGKsKqsR"
            },
            "followers": {
                "href": null,
                "total": 11769696
            },
            "genres": [
                "canadian contemporary r&b",
                "canadian pop",
                "pop"
            ],
            "href": "https://api.spotify.com/v1/artists/2wUjUUtkb5lvLKcGKsKqsR",
            "id": "2wUjUUtkb5lvLKcGKsKqsR",
            "images": [
                {
                    "height": 640,
                    "url": "https://i.scdn.co/image/ab6761610000e5ebe74b7398634a741f74858dc7",
                    "width": 640
                },
                {
                    "height": 320,
                    "url": "https://i.scdn.co/image/ab67616100005174e74b7398634a741f74858dc7",
                    "width": 320
                },
                {
                    "height": 160,
                    "url": "https://i.scdn.co/image/ab6761610000f178e74b7398634a741f74858dc7",
                    "width": 160
                }
            ],
            "name": "Alessia Cara",
            "popularity": 70,
            "type": "artist",
            "uri": "spotify:artist:2wUjUUtkb5lvLKcGKsKqsR"
        },
        "2SmW1lFlBJn4IfBzBZDlSh": {
            "external_urls": {
                "spotify": "https://open.spotify.com/artist/2SmW1lFlBJn4IfBzBZDlSh"
            },
            "followers": {
                "href": null,
                "total": 445543
            },
            "genres": [
                "mexican metal",
                "monterrey indie"
            ],
            "href": "https://api.spotify.com/v1/artists/2SmW1lFlBJn4IfBzBZDlSh",
            "id": "2SmW1lFlBJn4IfBzBZDlSh",
            "images": [
                {
                    "height": 640,
                    "url": "https://i.scdn.co/image/ab6761610000e5ebbf217572dc9f749377d70073",
                    "width": 640
                },
                {
                    "height": 320,
                    "url": "https://i.scdn.co/image/ab67616100005174bf217572dc9f749377d70073",
                    "width": 320
                },
                {
                    "height": 160,
                    "url": "https://i.scdn.co/image/ab6761610000f178bf217572dc9f749377d70073",
                    "width": 160
                }
            ],
            "name": "The Warning",
            "popularity": 58,
            "type": "artist",
            "uri": "spotify:artist:2SmW1lFlBJn4IfBzBZDlSh"
        },
        "3Sz7ZnJQBIHsXLUSo0OQtM": {
            "external_urls": {
                "spotify": "https://open.spotify.com/artist/3Sz7ZnJQBIHsXLUSo0OQtM"
            },
            "followers": {
                "href": null,
                "total": 5882787
            },
            "genres": [
                "edmonton indie",
                "lo-fi indie",
                "pov: indie",
                "slacker rock"
            ],
            "href": "https://api.spotify.com/v1/artists/3Sz7ZnJQBIHsXLUSo0OQtM",
            "id": "3Sz7ZnJQBIHsXLUSo0OQtM",
            "images": [
                {
                    "height": 640,
                    "url": "https://i.scdn.co/image/ab6761610000e5eb3cef7752073cbbd2cc04c6f0",
                    "width": 640
                },
                {
                    "height": 320,
                    "url": "https://i.scdn.co/image/ab676161000051743cef7752073cbbd2cc04c6f0",
                    "width": 320
                },
                {
                    "height": 160,
                    "url": "https://i.scdn.co/image/ab6761610000f1783cef7752073cbbd2cc04c6f0",
                    "width": 160
                }
            ],
            "name": "Mac DeMarco",
            "popularity": 77,
            "type": "artist",
            "uri": "spotify:artist:3Sz7ZnJQBIHsXLUSo0OQtM"
        },
        "1Qp56T7n950O3EGMsSl81D": {
            "external_urls": {
                "spotify": "https://open.spotify.com/artist/1Qp56T7n950O3EGMsSl81D"
            },
            "followers": {
                "href": null,
                "total": 3112572
            },
            "genres": [
                "hard rock",
                "metal"
            ],
            "href": "https://api.spotify.com/v1/artists/1Qp56T7n950O3EGMsSl81D",
            "id": "1Qp56T7n950O3EGMsSl81D",
            "images": [
                {
                    "height": 640,
                    "url": "https://i.scdn.co/image/ab6761610000e5eb6a6c34bd58bfd10b1e4557f0",
                    "width": 640
                },
                {
                    "height": 320,
                    "url": "https://i.scdn.co/image/ab676161000051746a6c34bd58bfd10b1e4557f0",
                    "width": 320
                },
                {
                    "height": 160,
                    "url": "https://i.scdn.co/image/ab6761610000f1786a6c34bd58bfd10b1e4557f0",
                    "width": 160
                }
            ],
            "name": "Ghost",
            "popularity": 71,
            "type": "artist",
            "uri": "spotify:artist:1Qp56T7n950O3EGMsSl81D"
        },
        "0UWZUmn7sybxMCqrw9tGa7": {
            "external_urls": {
                "spotify": "https://open.spotify.com/artist/0UWZUmn7sybxMCqrw9tGa7"
            },
            "followers": {
                "href": null,
                "total": 4725929
            },
            "genres": [
                "colombian pop",
                "latin pop",
                "mexican pop",
                "rock en espanol"
            ],
            "href": "https://api.spotify.com/v1/artists/0UWZUmn7sybxMCqrw9tGa7",
            "id": "0UWZUmn7sybxMCqrw9tGa7",
            "images": [
                {
                    "height": 640,
                    "url": "https://i.scdn.co/image/ab6761610000e5eb330d24db775125dcec2c7b4c",
                    "width": 640
                },
                {
                    "height": 320,
                    "url": "https://i.scdn.co/image/ab67616100005174330d24db775125dcec2c7b4c",
                    "width": 320
                },
                {
                    "height": 160,
                    "url": "https://i.scdn.co/image/ab6761610000f178330d24db775125dcec2c7b4c",
                    "width": 160
                }
            ],
            "name": "Juanes",
            "popularity": 74,
            "type": "artist",
            "uri": "spotify:artist:0UWZUmn7sybxMCqrw9tGa7"
        },
        "2KEqzdPS7M5YwGmiuPTdr5": {
            "external_urls": {
                "spotify": "https://open.spotify.com/artist/2KEqzdPS7M5YwGmiuPTdr5"
            },
            "followers": {
                "href": null,
                "total": 1021718
            },
            "genres": [
                "art pop",
                "electropop",
                "escape room",
                "indie pop"
            ],
            "href": "https://api.spotify.com/v1/artists/2KEqzdPS7M5YwGmiuPTdr5",
            "id": "2KEqzdPS7M5YwGmiuPTdr5",
            "images": [
                {
                    "height": 640,
                    "url": "https://i.scdn.co/image/ab6761610000e5eb8cb645e0a77bf015feda7fb9",
                    "width": 640
                },
                {
                    "height": 320,
                    "url": "https://i.scdn.co/image/ab676161000051748cb645e0a77bf015feda7fb9",
                    "width": 320
                },
                {
                    "height": 160,
                    "url": "https://i.scdn.co/image/ab6761610000f1788cb645e0a77bf015feda7fb9",
                    "width": 160
                }
            ],
            "name": "Rina Sawayama",
            "popularity": 58,
            "type": "artist",
            "uri": "spotify:artist:2KEqzdPS7M5YwGmiuPTdr5"
        },
        "3jOstUTkEu2JkjvRdBA5Gu": {
            "external_urls": {
                "spotify": "https://open.spotify.com/artist/3jOstUTkEu2JkjvRdBA5Gu"
            },
            "followers": {
                "href": null,
                "total": 3547894
            },
            "genres": [
                "alternative rock",
                "modern power pop",
                "modern rock",
                "permanent wave",
                "rock"
            ],
            "href": "https://api.spotify.com/v1/artists/3jOstUTkEu2JkjvRdBA5Gu",
            "id": "3jOstUTkEu2JkjvRdBA5Gu",
            "images": [
                {
                    "height": 640,
                    "url": "https://i.scdn.co/image/ab6761610000e5eb3cd35451daa1b690cfbbb2d4",
                    "width": 640
                },
                {
                    "height": 320,
                    "url": "https://i.scdn.co/image/ab676161000051743cd35451daa1b690cfbbb2d4",
                    "width": 320
                },
                {
                    "height": 160,
                    "url": "https://i.scdn.co/image/ab6761610000f1783cd35451daa1b690cfbbb2d4",
                    "width": 160
                }
            ],
            "name": "Weezer",
            "popularity": 72,
            "type": "artist",
            "uri": "spotify:artist:3jOstUTkEu2JkjvRdBA5Gu"
        },
        "6zlR5ttMfMNmwf2lecU9Cc": {
            "external_urls": {
                "spotify": "https://open.spotify.com/artist/6zlR5ttMfMNmwf2lecU9Cc"
            },
            "followers": {
                "href": null,
                "total": 887493
            },
            "genres": [
                "modern rock",
                "north east england indie"
            ],
            "href": "https://api.spotify.com/v1/artists/6zlR5ttMfMNmwf2lecU9Cc",
            "id": "6zlR5ttMfMNmwf2lecU9Cc",
            "images": [
                {
                    "height": 640,
                    "url": "https://i.scdn.co/image/ab6761610000e5eb3f024102223561c771cce4ed",
                    "width": 640
                },
                {
                    "height": 320,
                    "url": "https://i.scdn.co/image/ab676161000051743f024102223561c771cce4ed",
                    "width": 320
                },
                {
                    "height": 160,
                    "url": "https://i.scdn.co/image/ab6761610000f1783f024102223561c771cce4ed",
                    "width": 160
                }
            ],
            "name": "Sam Fender",
            "popularity": 65,
            "type": "artist",
            "uri": "spotify:artist:6zlR5ttMfMNmwf2lecU9Cc"
        },
        "3Lg3FGwBxOGuefqekQzRUf": {
            "external_urls": {
                "spotify": "https://open.spotify.com/artist/3Lg3FGwBxOGuefqekQzRUf"
            },
            "followers": {
                "href": null,
                "total": 246814
            },
            "genres": [
                "alternative country",
                "folk",
                "new americana",
                "roots rock"
            ],
            "href": "https://api.spotify.com/v1/artists/3Lg3FGwBxOGuefqekQzRUf",
            "id": "3Lg3FGwBxOGuefqekQzRUf",
            "images": [
                {
                    "height": 640,
                    "url": "https://i.scdn.co/image/ab6761610000e5ebf3ee3b123b3fdcd415559e5a",
                    "width": 640
                },
                {
                    "height": 320,
                    "url": "https://i.scdn.co/image/ab67616100005174f3ee3b123b3fdcd415559e5a",
                    "width": 320
                },
                {
                    "height": 160,
                    "url": "https://i.scdn.co/image/ab6761610000f178f3ee3b123b3fdcd415559e5a",
                    "width": 160
                }
            ],
            "name": "Jason Isbell and the 400 Unit",
            "popularity": 52,
            "type": "artist",
            "uri": "spotify:artist:3Lg3FGwBxOGuefqekQzRUf"
        },
        "4TPTW3cTwUtiihgOMSQfmy": {
            "external_urls": {
                "spotify": "https://open.spotify.com/artist/4TPTW3cTwUtiihgOMSQfmy"
            },
            "followers": {
                "href": null,
                "total": 160819
            },
            "genres": [
                "latin alternative",
                "mexican indie",
                "mexican rock"
            ],
            "href": "https://api.spotify.com/v1/artists/4TPTW3cTwUtiihgOMSQfmy",
            "id": "4TPTW3cTwUtiihgOMSQfmy",
            "images": [
                {
                    "height": 640,
                    "url": "https://i.scdn.co/image/ab6761610000e5eb1561734cc5bf93599d70ffaf",
                    "width": 640
                },
                {
                    "height": 320,
                    "url": "https://i.scdn.co/image/ab676161000051741561734cc5bf93599d70ffaf",
                    "width": 320
                },
                {
                    "height": 160,
                    "url": "https://i.scdn.co/image/ab6761610000f1781561734cc5bf93599d70ffaf",
                    "width": 160
                }
            ],
            "name": "Mexican Institute Of Sound",
            "popularity": 43,
            "type": "artist",
            "uri": "spotify:artist:4TPTW3cTwUtiihgOMSQfmy"
        },
        "1CJIcvG0AwRBiclbftNcDp": {
            "external_urls": {
                "spotify": "https://open.spotify.com/artist/1CJIcvG0AwRBiclbftNcDp"
            },
            "followers": {
                "href": null,
                "total": 17405
            },
            "genres": [
                "tropical alternativo"
            ],
            "href": "https://api.spotify.com/v1/artists/1CJIcvG0AwRBiclbftNcDp",
            "id": "1CJIcvG0AwRBiclbftNcDp",
            "images": [
                {
                    "height": 640,
                    "url": "https://i.scdn.co/image/ab6761610000e5ebf2856a52c6ad7374b6e3a4b4",
                    "width": 640
                },
                {
                    "height": 320,
                    "url": "https://i.scdn.co/image/ab67616100005174f2856a52c6ad7374b6e3a4b4",
                    "width": 320
                },
                {
                    "height": 160,
                    "url": "https://i.scdn.co/image/ab6761610000f178f2856a52c6ad7374b6e3a4b4",
                    "width": 160
                }
            ],
            "name": "La Perla",
            "popularity": 30,
            "type": "artist",
            "uri": "spotify:artist:1CJIcvG0AwRBiclbftNcDp"
        },
        "2hejA1Dkf8v8R0koF44FvW": {
            "external_urls": {
                "spotify": "https://open.spotify.com/artist/2hejA1Dkf8v8R0koF44FvW"
            },
            "followers": {
                "href": null,
                "total": 4824449
            },
            "genres": [
                "mexican hip hop",
                "rap conciencia"
            ],
            "href": "https://api.spotify.com/v1/artists/2hejA1Dkf8v8R0koF44FvW",
            "id": "2hejA1Dkf8v8R0koF44FvW",
            "images": [
                {
                    "height": 640,
                    "url": "https://i.scdn.co/image/ab6761610000e5ebd538754c49d48ea3ae41865e",
                    "width": 640
                },
                {
                    "height": 320,
                    "url": "https://i.scdn.co/image/ab67616100005174d538754c49d48ea3ae41865e",
                    "width": 320
                },
                {
                    "height": 160,
                    "url": "https://i.scdn.co/image/ab6761610000f178d538754c49d48ea3ae41865e",
                    "width": 160
                }
            ],
            "name": "Gera MX",
            "popularity": 74,
            "type": "artist",
            "uri": "spotify:artist:2hejA1Dkf8v8R0koF44FvW"
        },
        "2ye2Wgw4gimLv2eAKyk1NB": {
            "external_urls": {
                "spotify": "https://open.spotify.com/artist/2ye2Wgw4gimLv2eAKyk1NB"
            },
            "followers": {
                "href": null,
                "total": 27179867
            },
            "genres": [
                "hard rock",
                "metal",
                "old school thrash",
                "rock",
                "thrash metal"
            ],
            "href": "https://api.spotify.com/v1/artists/2ye2Wgw4gimLv2eAKyk1NB",
            "id": "2ye2Wgw4gimLv2eAKyk1NB",
            "images": [
                {
                    "height": 640,
                    "url": "https://i.scdn.co/image/ab6761610000e5eb69ca98dd3083f1082d740e44",
                    "width": 640
                },
                {
                    "height": 320,
                    "url": "https://i.scdn.co/image/ab6761610000517469ca98dd3083f1082d740e44",
                    "width": 320
                },
                {
                    "height": 160,
                    "url": "https://i.scdn.co/image/ab6761610000f17869ca98dd3083f1082d740e44",
                    "width": 160
                }
            ],
            "name": "Metallica",
            "popularity": 80,
            "type": "artist",
            "uri": "spotify:artist:2ye2Wgw4gimLv2eAKyk1NB"
        },
        "2S5hlvw4CMtMGswFtfdK15": {
            "external_urls": {
                "spotify": "https://open.spotify.com/artist/2S5hlvw4CMtMGswFtfdK15"
            },
            "followers": {
                "href": null,
                "total": 1621363
            },
            "genres": [
                "brighton indie",
                "garage rock",
                "modern alternative rock",
                "modern blues rock",
                "modern hard rock",
                "modern rock",
                "rock"
            ],
            "href": "https://api.spotify.com/v1/artists/2S5hlvw4CMtMGswFtfdK15",
            "id": "2S5hlvw4CMtMGswFtfdK15",
            "images": [
                {
                    "height": 640,
                    "url": "https://i.scdn.co/image/ab6761610000e5eb731a9ef85c9a9b208399770f",
                    "width": 640
                },
                {
                    "height": 320,
                    "url": "https://i.scdn.co/image/ab67616100005174731a9ef85c9a9b208399770f",
                    "width": 320
                },
                {
                    "height": 160,
                    "url": "https://i.scdn.co/image/ab6761610000f178731a9ef85c9a9b208399770f",
                    "width": 160
                }
            ],
            "name": "Royal Blood",
            "popularity": 61,
            "type": "artist",
            "uri": "spotify:artist:2S5hlvw4CMtMGswFtfdK15"
        },
        "7bcbShaqKdcyjnmv4Ix8j6": {
            "external_urls": {
                "spotify": "https://open.spotify.com/artist/7bcbShaqKdcyjnmv4Ix8j6"
            },
            "followers": {
                "href": null,
                "total": 869367
            },
            "genres": [
                "art pop",
                "etherpop",
                "indie rock",
                "indietronica",
                "metropopolis",
                "neo-synthpop"
            ],
            "href": "https://api.spotify.com/v1/artists/7bcbShaqKdcyjnmv4Ix8j6",
            "id": "7bcbShaqKdcyjnmv4Ix8j6",
            "images": [
                {
                    "height": 640,
                    "url": "https://i.scdn.co/image/ab6761610000e5ebbb8bc9aace3d4d39d7cfd6f1",
                    "width": 640
                },
                {
                    "height": 320,
                    "url": "https://i.scdn.co/image/ab67616100005174bb8bc9aace3d4d39d7cfd6f1",
                    "width": 320
                },
                {
                    "height": 160,
                    "url": "https://i.scdn.co/image/ab6761610000f178bb8bc9aace3d4d39d7cfd6f1",
                    "width": 160
                }
            ],
            "name": "St. Vincent",
            "popularity": 63,
            "type": "artist",
            "uri": "spotify:artist:7bcbShaqKdcyjnmv4Ix8j6"
        },
        "75klPfIVnyYcyEGaicRUSF": {
            "external_urls": {
                "spotify": "https://open.spotify.com/artist/75klPfIVnyYcyEGaicRUSF"
            },
            "followers": {
                "href": null,
                "total": 90233
            },
            "genres": [
                "indie punk",
                "louisville indie",
                "modern power pop"
            ],
            "href": "https://api.spotify.com/v1/artists/75klPfIVnyYcyEGaicRUSF",
            "id": "75klPfIVnyYcyEGaicRUSF",
            "images": [
                {
                    "height": 640,
                    "url": "https://i.scdn.co/image/ab6761610000e5eb0b9e56face673e872ccdf2d9",
                    "width": 640
                },
                {
                    "height": 320,
                    "url": "https://i.scdn.co/image/ab676161000051740b9e56face673e872ccdf2d9",
                    "width": 320
                },
                {
                    "height": 160,
                    "url": "https://i.scdn.co/image/ab6761610000f1780b9e56face673e872ccdf2d9",
                    "width": 160
                }
            ],
            "name": "White Reaper",
            "popularity": 42,
            "type": "artist",
            "uri": "spotify:artist:75klPfIVnyYcyEGaicRUSF"
        },
        "1rpgxJZxZMLnFNc1Jmyov5": {
            "external_urls": {
                "spotify": "https://open.spotify.com/artist/1rpgxJZxZMLnFNc1Jmyov5"
            },
            "followers": {
                "href": null,
                "total": 20658
            },
            "genres": [
                "k-rock",
                "korean indie rock"
            ],
            "href": "https://api.spotify.com/v1/artists/1rpgxJZxZMLnFNc1Jmyov5",
            "id": "1rpgxJZxZMLnFNc1Jmyov5",
            "images": [
                {
                    "height": 640,
                    "url": "https://i.scdn.co/image/ab6761610000e5eb1ecf93514aaa79d02826707e",
                    "width": 640
                },
                {
                    "height": 320,
                    "url": "https://i.scdn.co/image/ab676161000051741ecf93514aaa79d02826707e",
                    "width": 320
                },
                {
                    "height": 160,
                    "url": "https://i.scdn.co/image/ab6761610000f1781ecf93514aaa79d02826707e",
                    "width": 160
                }
            ],
            "name": "YB",
            "popularity": 33,
            "type": "artist",
            "uri": "spotify:artist:1rpgxJZxZMLnFNc1Jmyov5"
        },
        "1km0R7wy712AzLkA1WjKET": {
            "external_urls": {
                "spotify": "https://open.spotify.com/artist/1km0R7wy712AzLkA1WjKET"
            },
            "followers": {
                "href": null,
                "total": 716280
            },
            "genres": [
                "modern rock",
                "scottish rock"
            ],
            "href": "https://api.spotify.com/v1/artists/1km0R7wy712AzLkA1WjKET",
            "id": "1km0R7wy712AzLkA1WjKET",
            "images": [
                {
                    "height": 640,
                    "url": "https://i.scdn.co/image/ab6761610000e5eb5a8702315c7ddff8eb7b69ba",
                    "width": 640
                },
                {
                    "height": 320,
                    "url": "https://i.scdn.co/image/ab676161000051745a8702315c7ddff8eb7b69ba",
                    "width": 320
                },
                {
                    "height": 160,
                    "url": "https://i.scdn.co/image/ab6761610000f1785a8702315c7ddff8eb7b69ba",
                    "width": 160
                }
            ],
            "name": "Biffy Clyro",
            "popularity": 54,
            "type": "artist",
            "uri": "spotify:artist:1km0R7wy712AzLkA1WjKET"
        },
        "1aQ7P3HtKOQFW16ebjiks1": {
            "external_urls": {
                "spotify": "https://open.spotify.com/artist/1aQ7P3HtKOQFW16ebjiks1"
            },
            "followers": {
                "href": null,
                "total": 286581
            },
            "genres": [
                "australian garage punk",
                "brisbane punk"
            ],
            "href": "https://api.spotify.com/v1/artists/1aQ7P3HtKOQFW16ebjiks1",
            "id": "1aQ7P3HtKOQFW16ebjiks1",
            "images": [
                {
                    "height": 640,
                    "url": "https://i.scdn.co/image/ab6761610000e5eba43a92d50e11b126604d710e",
                    "width": 640
                },
                {
                    "height": 320,
                    "url": "https://i.scdn.co/image/ab67616100005174a43a92d50e11b126604d710e",
                    "width": 320
                },
                {
                    "height": 160,
                    "url": "https://i.scdn.co/image/ab6761610000f178a43a92d50e11b126604d710e",
                    "width": 160
                }
            ],
            "name": "The Chats",
            "popularity": 49,
            "type": "artist",
            "uri": "spotify:artist:1aQ7P3HtKOQFW16ebjiks1"
        },
        "4fY9hRf8gHMOszNWFhR1wB": {
            "external_urls": {
                "spotify": "https://open.spotify.com/artist/4fY9hRf8gHMOszNWFhR1wB"
            },
            "followers": {
                "href": null,
                "total": 61726
            },
            "genres": [
                "hardcore punk",
                "punk"
            ],
            "href": "https://api.spotify.com/v1/artists/4fY9hRf8gHMOszNWFhR1wB",
            "id": "4fY9hRf8gHMOszNWFhR1wB",
            "images": [
                {
                    "height": 640,
                    "url": "https://i.scdn.co/image/ab6761610000e5eb57688e3e37f87319bfd0e891",
                    "width": 640
                },
                {
                    "height": 320,
                    "url": "https://i.scdn.co/image/ab6761610000517457688e3e37f87319bfd0e891",
                    "width": 320
                },
                {
                    "height": 160,
                    "url": "https://i.scdn.co/image/ab6761610000f17857688e3e37f87319bfd0e891",
                    "width": 160
                }
            ],
            "name": "OFF!",
            "popularity": 30,
            "type": "artist",
            "uri": "spotify:artist:4fY9hRf8gHMOszNWFhR1wB"
        },
        "6A7uqgC2N1nUhrCLAytHxN": {
            "external_urls": {
                "spotify": "https://open.spotify.com/artist/6A7uqgC2N1nUhrCLAytHxN"
            },
            "followers": {
                "href": null,
                "total": 256906
            },
            "genres": [
                "alternative emo",
                "bubblegrunge",
                "canadian indie",
                "canadian pop punk",
                "canadian punk",
                "emo",
                "indie punk",
                "toronto indie"
            ],
            "href": "https://api.spotify.com/v1/artists/6A7uqgC2N1nUhrCLAytHxN",
            "id": "6A7uqgC2N1nUhrCLAytHxN",
            "images": [
                {
                    "height": 640,
                    "url": "https://i.scdn.co/image/ab6761610000e5eb3c01e2c45dcbdca5a953b469",
                    "width": 640
                },
                {
                    "height": 320,
                    "url": "https://i.scdn.co/image/ab676161000051743c01e2c45dcbdca5a953b469",
                    "width": 320
                },
                {
                    "height": 160,
                    "url": "https://i.scdn.co/image/ab6761610000f1783c01e2c45dcbdca5a953b469",
                    "width": 160
                }
            ],
            "name": "PUP",
            "popularity": 48,
            "type": "artist",
            "uri": "spotify:artist:6A7uqgC2N1nUhrCLAytHxN"
        },
        "0nhDd1RWjZ6SDV1Vg1Ku2Q": {
            "external_urls": {
                "spotify": "https://open.spotify.com/artist/0nhDd1RWjZ6SDV1Vg1Ku2Q"
            },
            "followers": {
                "href": null,
                "total": 590402
            },
            "genres": [
                "alternative metal",
                "alternative rock",
                "nu metal",
                "post-grunge"
            ],
            "href": "https://api.spotify.com/v1/artists/0nhDd1RWjZ6SDV1Vg1Ku2Q",
            "id": "0nhDd1RWjZ6SDV1Vg1Ku2Q",
            "images": [
                {
                    "height": 640,
                    "url": "https://i.scdn.co/image/ab6761610000e5eb010a6b118f23106c00bef4a9",
                    "width": 640
                },
                {
                    "height": 320,
                    "url": "https://i.scdn.co/image/ab67616100005174010a6b118f23106c00bef4a9",
                    "width": 320
                },
                {
                    "height": 160,
                    "url": "https://i.scdn.co/image/ab6761610000f178010a6b118f23106c00bef4a9",
                    "width": 160
                }
            ],
            "name": "Corey Taylor",
            "popularity": 54,
            "type": "artist",
            "uri": "spotify:artist:0nhDd1RWjZ6SDV1Vg1Ku2Q"
        },
        "26T3LtbuGT1Fu9m0eRq5X3": {
            "external_urls": {
                "spotify": "https://open.spotify.com/artist/26T3LtbuGT1Fu9m0eRq5X3"
            },
            "followers": {
                "href": null,
                "total": 3713988
            },
            "genres": [
                "modern alternative rock",
                "modern rock",
                "pov: indie",
                "punk blues",
                "rock"
            ],
            "href": "https://api.spotify.com/v1/artists/26T3LtbuGT1Fu9m0eRq5X3",
            "id": "26T3LtbuGT1Fu9m0eRq5X3",
            "images": [
                {
                    "height": 640,
                    "url": "https://i.scdn.co/image/ab6761610000e5eb4b895ec91da05e35c650fa60",
                    "width": 640
                },
                {
                    "height": 320,
                    "url": "https://i.scdn.co/image/ab676161000051744b895ec91da05e35c650fa60",
                    "width": 320
                },
                {
                    "height": 160,
                    "url": "https://i.scdn.co/image/ab6761610000f1784b895ec91da05e35c650fa60",
                    "width": 160
                }
            ],
            "name": "Cage The Elephant",
            "popularity": 73,
            "type": "artist",
            "uri": "spotify:artist:26T3LtbuGT1Fu9m0eRq5X3"
        },
        "6CXEwIaXYfVJ84biCxqc9k": {
            "external_urls": {
                "spotify": "https://open.spotify.com/artist/6CXEwIaXYfVJ84biCxqc9k"
            },
            "followers": {
                "href": null,
                "total": 11256602
            },
            "genres": [
                "filmi",
                "modern bollywood"
            ],
            "href": "https://api.spotify.com/v1/artists/6CXEwIaXYfVJ84biCxqc9k",
            "id": "6CXEwIaXYfVJ84biCxqc9k",
            "images": [
                {
                    "height": 640,
                    "url": "https://i.scdn.co/image/ab6761610000e5eb76328e37a2c1280ab9adb90c",
                    "width": 640
                },
                {
                    "height": 320,
                    "url": "https://i.scdn.co/image/ab6761610000517476328e37a2c1280ab9adb90c",
                    "width": 320
                },
                {
                    "height": 160,
                    "url": "https://i.scdn.co/image/ab6761610000f17876328e37a2c1280ab9adb90c",
                    "width": 160
                }
            ],
            "name": "Vishal Dadlani",
            "popularity": 71,
            "type": "artist",
            "uri": "spotify:artist:6CXEwIaXYfVJ84biCxqc9k"
        },
        "4Ai0pGz6GhQavjzaRhPTvz": {
            "external_urls": {
                "spotify": "https://open.spotify.com/artist/4Ai0pGz6GhQavjzaRhPTvz"
            },
            "followers": {
                "href": null,
                "total": 5595991
            },
            "genres": [
                "desi hip hop",
                "desi trap",
                "hindi hip hop"
            ],
            "href": "https://api.spotify.com/v1/artists/4Ai0pGz6GhQavjzaRhPTvz",
            "id": "4Ai0pGz6GhQavjzaRhPTvz",
            "images": [
                {
                    "height": 640,
                    "url": "https://i.scdn.co/image/ab6761610000e5ebe4bae1cd1803402a906b61ba",
                    "width": 640
                },
                {
                    "height": 320,
                    "url": "https://i.scdn.co/image/ab67616100005174e4bae1cd1803402a906b61ba",
                    "width": 320
                },
                {
                    "height": 160,
                    "url": "https://i.scdn.co/image/ab6761610000f178e4bae1cd1803402a906b61ba",
                    "width": 160
                }
            ],
            "name": "DIVINE",
            "popularity": 66,
            "type": "artist",
            "uri": "spotify:artist:4Ai0pGz6GhQavjzaRhPTvz"
        },
        "58Wsx9FbcjSM8a6kzLf03W": {
            "external_urls": {
                "spotify": "https://open.spotify.com/artist/58Wsx9FbcjSM8a6kzLf03W"
            },
            "followers": {
                "href": null,
                "total": 587
            },
            "genres": [],
            "href": "https://api.spotify.com/v1/artists/58Wsx9FbcjSM8a6kzLf03W",
            "id": "58Wsx9FbcjSM8a6kzLf03W",
            "images": [
                {
                    "height": 640,
                    "url": "https://i.scdn.co/image/ab6761610000e5eb296cb8cb713b666b22df731d",
                    "width": 640
                },
                {
                    "height": 320,
                    "url": "https://i.scdn.co/image/ab67616100005174296cb8cb713b666b22df731d",
                    "width": 320
                },
                {
                    "height": 160,
                    "url": "https://i.scdn.co/image/ab6761610000f178296cb8cb713b666b22df731d",
                    "width": 160
                }
            ],
            "name": "Shor Police",
            "popularity": 17,
            "type": "artist",
            "uri": "spotify:artist:58Wsx9FbcjSM8a6kzLf03W"
        },
        "6ommlbuccgdiKSgjvVlQ4W": {
            "external_urls": {
                "spotify": "https://open.spotify.com/artist/6ommlbuccgdiKSgjvVlQ4W"
            },
            "followers": {
                "href": null,
                "total": 73753
            },
            "genres": [
                "bubblegrunge",
                "indie punk"
            ],
            "href": "https://api.spotify.com/v1/artists/6ommlbuccgdiKSgjvVlQ4W",
            "id": "6ommlbuccgdiKSgjvVlQ4W",
            "images": [
                {
                    "height": 640,
                    "url": "https://i.scdn.co/image/ab6761610000e5eb9a0962323fbf23d1e625f3d1",
                    "width": 640
                },
                {
                    "height": 320,
                    "url": "https://i.scdn.co/image/ab676161000051749a0962323fbf23d1e625f3d1",
                    "width": 320
                },
                {
                    "height": 160,
                    "url": "https://i.scdn.co/image/ab6761610000f1789a0962323fbf23d1e625f3d1",
                    "width": 160
                }
            ],
            "name": "Diet Cig",
            "popularity": 27,
            "type": "artist",
            "uri": "spotify:artist:6ommlbuccgdiKSgjvVlQ4W"
        },
        "1dqGS5sT6PE2wEvP1gROZC": {
            "external_urls": {
                "spotify": "https://open.spotify.com/artist/1dqGS5sT6PE2wEvP1gROZC"
            },
            "followers": {
                "href": null,
                "total": 1215931
            },
            "genres": [
                "psychedelic hip hop",
                "underground hip hop"
            ],
            "href": "https://api.spotify.com/v1/artists/1dqGS5sT6PE2wEvP1gROZC",
            "id": "1dqGS5sT6PE2wEvP1gROZC",
            "images": [
                {
                    "height": 640,
                    "url": "https://i.scdn.co/image/ab6761610000e5eb48807b66b83a3ce51ee9504f",
                    "width": 640
                },
                {
                    "height": 320,
                    "url": "https://i.scdn.co/image/ab6761610000517448807b66b83a3ce51ee9504f",
                    "width": 320
                },
                {
                    "height": 160,
                    "url": "https://i.scdn.co/image/ab6761610000f17848807b66b83a3ce51ee9504f",
                    "width": 160
                }
            ],
            "name": "Flatbush Zombies",
            "popularity": 53,
            "type": "artist",
            "uri": "spotify:artist:1dqGS5sT6PE2wEvP1gROZC"
        },
        "4vBBOm1tR7WToK4DZmDZAd": {
            "external_urls": {
                "spotify": "https://open.spotify.com/artist/4vBBOm1tR7WToK4DZmDZAd"
            },
            "followers": {
                "href": null,
                "total": 3774
            },
            "genres": [],
            "href": "https://api.spotify.com/v1/artists/4vBBOm1tR7WToK4DZmDZAd",
            "id": "4vBBOm1tR7WToK4DZmDZAd",
            "images": [
                {
                    "height": 640,
                    "url": "https://i.scdn.co/image/ab6761610000e5ebb886d90aafad5d8ad5e96e13",
                    "width": 640
                },
                {
                    "height": 320,
                    "url": "https://i.scdn.co/image/ab67616100005174b886d90aafad5d8ad5e96e13",
                    "width": 320
                },
                {
                    "height": 160,
                    "url": "https://i.scdn.co/image/ab6761610000f178b886d90aafad5d8ad5e96e13",
                    "width": 160
                }
            ],
            "name": "DJ Scratch",
            "popularity": 22,
            "type": "artist",
            "uri": "spotify:artist:4vBBOm1tR7WToK4DZmDZAd"
        },
        "5xd2Tg7Zo8755eCy8Gxkp8": {
            "external_urls": {
                "spotify": "https://open.spotify.com/artist/5xd2Tg7Zo8755eCy8Gxkp8"
            },
            "followers": {
                "href": null,
                "total": 8317138
            },
            "genres": [
                "latin arena pop",
                "latin pop",
                "mexican pop"
            ],
            "href": "https://api.spotify.com/v1/artists/5xd2Tg7Zo8755eCy8Gxkp8",
            "id": "5xd2Tg7Zo8755eCy8Gxkp8",
            "images": [
                {
                    "height": 640,
                    "url": "https://i.scdn.co/image/ab6761610000e5ebaae7c43a4f71d534555d6e36",
                    "width": 640
                },
                {
                    "height": 320,
                    "url": "https://i.scdn.co/image/ab67616100005174aae7c43a4f71d534555d6e36",
                    "width": 320
                },
                {
                    "height": 160,
                    "url": "https://i.scdn.co/image/ab6761610000f178aae7c43a4f71d534555d6e36",
                    "width": 160
                }
            ],
            "name": "Ha*Ash",
            "popularity": 72,
            "type": "artist",
            "uri": "spotify:artist:5xd2Tg7Zo8755eCy8Gxkp8"
        },
        "62nVRNDLaS8m1p31F6omGw": {
            "external_urls": {
                "spotify": "https://open.spotify.com/artist/62nVRNDLaS8m1p31F6omGw"
            },
            "followers": {
                "href": null,
                "total": 427565
            },
            "genres": [
                "mexican indie"
            ],
            "href": "https://api.spotify.com/v1/artists/62nVRNDLaS8m1p31F6omGw",
            "id": "62nVRNDLaS8m1p31F6omGw",
            "images": [
                {
                    "height": 640,
                    "url": "https://i.scdn.co/image/ab6761610000e5eb3ed411c2b88b61821064dd7c",
                    "width": 640
                },
                {
                    "height": 320,
                    "url": "https://i.scdn.co/image/ab676161000051743ed411c2b88b61821064dd7c",
                    "width": 320
                },
                {
                    "height": 160,
                    "url": "https://i.scdn.co/image/ab6761610000f1783ed411c2b88b61821064dd7c",
                    "width": 160
                }
            ],
            "name": "Jos\u00e9 Madero",
            "popularity": 61,
            "type": "artist",
            "uri": "spotify:artist:62nVRNDLaS8m1p31F6omGw"
        },
        "5W10uJRsbt9bROJDKoI1Wn": {
            "external_urls": {
                "spotify": "https://open.spotify.com/artist/5W10uJRsbt9bROJDKoI1Wn"
            },
            "followers": {
                "href": null,
                "total": 362696
            },
            "genres": [
                "alternative r&b",
                "art pop",
                "indie soul",
                "la pop"
            ],
            "href": "https://api.spotify.com/v1/artists/5W10uJRsbt9bROJDKoI1Wn",
            "id": "5W10uJRsbt9bROJDKoI1Wn",
            "images": [
                {
                    "height": 640,
                    "url": "https://i.scdn.co/image/ab6761610000e5ebfd650ed577201c1fe030e293",
                    "width": 640
                },
                {
                    "height": 320,
                    "url": "https://i.scdn.co/image/ab67616100005174fd650ed577201c1fe030e293",
                    "width": 320
                },
                {
                    "height": 160,
                    "url": "https://i.scdn.co/image/ab6761610000f178fd650ed577201c1fe030e293",
                    "width": 160
                }
            ],
            "name": "Moses Sumney",
            "popularity": 56,
            "type": "artist",
            "uri": "spotify:artist:5W10uJRsbt9bROJDKoI1Wn"
        },
        "1vyhD5VmyZ7KMfW5gqLgo5": {
            "external_urls": {
                "spotify": "https://open.spotify.com/artist/1vyhD5VmyZ7KMfW5gqLgo5"
            },
            "followers": {
                "href": null,
                "total": 36561592
            },
            "genres": [
                "reggaeton",
                "reggaeton colombiano",
                "trap latino",
                "urbano latino"
            ],
            "href": "https://api.spotify.com/v1/artists/1vyhD5VmyZ7KMfW5gqLgo5",
            "id": "1vyhD5VmyZ7KMfW5gqLgo5",
            "images": [
                {
                    "height": 640,
                    "url": "https://i.scdn.co/image/ab6761610000e5ebeacb832512fec776bbdac3a6",
                    "width": 640
                },
                {
                    "height": 320,
                    "url": "https://i.scdn.co/image/ab67616100005174eacb832512fec776bbdac3a6",
                    "width": 320
                },
                {
                    "height": 160,
                    "url": "https://i.scdn.co/image/ab6761610000f178eacb832512fec776bbdac3a6",
                    "width": 160
                }
            ],
            "name": "J Balvin",
            "popularity": 84,
            "type": "artist",
            "uri": "spotify:artist:1vyhD5VmyZ7KMfW5gqLgo5"
        },
        "3jNkaOXasoc7RsxdchvEVq": {
            "external_urls": {
                "spotify": "https://open.spotify.com/artist/3jNkaOXasoc7RsxdchvEVq"
            },
            "followers": {
                "href": null,
                "total": 915827
            },
            "genres": [
                "dancefloor dnb",
                "drum and bass",
                "uk dance"
            ],
            "href": "https://api.spotify.com/v1/artists/3jNkaOXasoc7RsxdchvEVq",
            "id": "3jNkaOXasoc7RsxdchvEVq",
            "images": [
                {
                    "height": 640,
                    "url": "https://i.scdn.co/image/ab6761610000e5ebd99e4a93d2db662b7a9325be",
                    "width": 640
                },
                {
                    "height": 320,
                    "url": "https://i.scdn.co/image/ab67616100005174d99e4a93d2db662b7a9325be",
                    "width": 320
                },
                {
                    "height": 160,
                    "url": "https://i.scdn.co/image/ab6761610000f178d99e4a93d2db662b7a9325be",
                    "width": 160
                }
            ],
            "name": "Chase & Status",
            "popularity": 67,
            "type": "artist",
            "uri": "spotify:artist:3jNkaOXasoc7RsxdchvEVq"
        },
        "51op6E2hjkeutwFhgw32mL": {
            "external_urls": {
                "spotify": "https://open.spotify.com/artist/51op6E2hjkeutwFhgw32mL"
            },
            "followers": {
                "href": null,
                "total": 35508
            },
            "genres": [
                "grime",
                "uk hip hop"
            ],
            "href": "https://api.spotify.com/v1/artists/51op6E2hjkeutwFhgw32mL",
            "id": "51op6E2hjkeutwFhgw32mL",
            "images": [
                {
                    "height": 640,
                    "url": "https://i.scdn.co/image/ab6761610000e5eb8b5fed9e517dfb8ac3a7c39c",
                    "width": 640
                },
                {
                    "height": 320,
                    "url": "https://i.scdn.co/image/ab676161000051748b5fed9e517dfb8ac3a7c39c",
                    "width": 320
                },
                {
                    "height": 160,
                    "url": "https://i.scdn.co/image/ab6761610000f1788b5fed9e517dfb8ac3a7c39c",
                    "width": 160
                }
            ],
            "name": "BackRoad Gee",
            "popularity": 39,
            "type": "artist",
            "uri": "spotify:artist:51op6E2hjkeutwFhgw32mL"
        },
        "0KuF7reCTOZwV7YJnHQqgr": {
            "external_urls": {
                "spotify": "https://open.spotify.com/artist/0KuF7reCTOZwV7YJnHQqgr"
            },
            "followers": {
                "href": null,
                "total": 98657
            },
            "genres": [],
            "href": "https://api.spotify.com/v1/artists/0KuF7reCTOZwV7YJnHQqgr",
            "id": "0KuF7reCTOZwV7YJnHQqgr",
            "images": [
                {
                    "height": 640,
                    "url": "https://i.scdn.co/image/ab6761610000e5ebcf7dcb181fc5db70e2252aac",
                    "width": 640
                },
                {
                    "height": 320,
                    "url": "https://i.scdn.co/image/ab67616100005174cf7dcb181fc5db70e2252aac",
                    "width": 320
                },
                {
                    "height": 160,
                    "url": "https://i.scdn.co/image/ab6761610000f178cf7dcb181fc5db70e2252aac",
                    "width": 160
                }
            ],
            "name": "The Neptunes",
            "popularity": 54,
            "type": "artist",
            "uri": "spotify:artist:0KuF7reCTOZwV7YJnHQqgr"
        },
        "4MoAOfV4ROWofLG3a3hhBN": {
            "external_urls": {
                "spotify": "https://open.spotify.com/artist/4MoAOfV4ROWofLG3a3hhBN"
            },
            "followers": {
                "href": null,
                "total": 1985803
            },
            "genres": [
                "contemporary country",
                "country",
                "country road",
                "modern country rock"
            ],
            "href": "https://api.spotify.com/v1/artists/4MoAOfV4ROWofLG3a3hhBN",
            "id": "4MoAOfV4ROWofLG3a3hhBN",
            "images": [
                {
                    "height": 640,
                    "url": "https://i.scdn.co/image/ab6761610000e5eb9ab434ef1b8d8aff5fce625d",
                    "width": 640
                },
                {
                    "height": 320,
                    "url": "https://i.scdn.co/image/ab676161000051749ab434ef1b8d8aff5fce625d",
                    "width": 320
                },
                {
                    "height": 160,
                    "url": "https://i.scdn.co/image/ab6761610000f1789ab434ef1b8d8aff5fce625d",
                    "width": 160
                }
            ],
            "name": "Jon Pardi",
            "popularity": 72,
            "type": "artist",
            "uri": "spotify:artist:4MoAOfV4ROWofLG3a3hhBN"
        },
        "5tOWIviwLM1EIqGAbF8VSU": {
            "external_urls": {
                "spotify": "https://open.spotify.com/artist/5tOWIviwLM1EIqGAbF8VSU"
            },
            "followers": {
                "href": null,
                "total": 131695
            },
            "genres": [
                "filter house"
            ],
            "href": "https://api.spotify.com/v1/artists/5tOWIviwLM1EIqGAbF8VSU",
            "id": "5tOWIviwLM1EIqGAbF8VSU",
            "images": [
                {
                    "height": 640,
                    "url": "https://i.scdn.co/image/ab6761610000e5ebfea5e67c21857e7c997d3efc",
                    "width": 640
                },
                {
                    "height": 320,
                    "url": "https://i.scdn.co/image/ab67616100005174fea5e67c21857e7c997d3efc",
                    "width": 320
                },
                {
                    "height": 160,
                    "url": "https://i.scdn.co/image/ab6761610000f178fea5e67c21857e7c997d3efc",
                    "width": 160
                }
            ],
            "name": "SebastiAn",
            "popularity": 40,
            "type": "artist",
            "uri": "spotify:artist:5tOWIviwLM1EIqGAbF8VSU"
        },
        "4kI8Ie27vjvonwaB2ePh8T": {
            "external_urls": {
                "spotify": "https://open.spotify.com/artist/4kI8Ie27vjvonwaB2ePh8T"
            },
            "followers": {
                "href": null,
                "total": 1438055
            },
            "genres": [
                "indie rock",
                "indietronica",
                "modern alternative rock",
                "modern rock"
            ],
            "href": "https://api.spotify.com/v1/artists/4kI8Ie27vjvonwaB2ePh8T",
            "id": "4kI8Ie27vjvonwaB2ePh8T",
            "images": [
                {
                    "height": 640,
                    "url": "https://i.scdn.co/image/ab6761610000e5ebe20c61457ea3c2fdef20c326",
                    "width": 640
                },
                {
                    "height": 320,
                    "url": "https://i.scdn.co/image/ab67616100005174e20c61457ea3c2fdef20c326",
                    "width": 320
                },
                {
                    "height": 160,
                    "url": "https://i.scdn.co/image/ab6761610000f178e20c61457ea3c2fdef20c326",
                    "width": 160
                }
            ],
            "name": "Portugal. The Man",
            "popularity": 64,
            "type": "artist",
            "uri": "spotify:artist:4kI8Ie27vjvonwaB2ePh8T"
        },
        "3jD4LaXdTKzJJuarvH62mj": {
            "external_urls": {
                "spotify": "https://open.spotify.com/artist/3jD4LaXdTKzJJuarvH62mj"
            },
            "followers": {
                "href": null,
                "total": 47
            },
            "genres": [],
            "href": "https://api.spotify.com/v1/artists/3jD4LaXdTKzJJuarvH62mj",
            "id": "3jD4LaXdTKzJJuarvH62mj",
            "images": [],
            "name": "Aaron Beam",
            "popularity": 11,
            "type": "artist",
            "uri": "spotify:artist:3jD4LaXdTKzJJuarvH62mj"
        },
        "0L5fC7Ogm2YwgqVCRcF1bT": {
            "external_urls": {
                "spotify": "https://open.spotify.com/artist/0L5fC7Ogm2YwgqVCRcF1bT"
            },
            "followers": {
                "href": null,
                "total": 2498132
            },
            "genres": [
                "danish metal",
                "danish rock"
            ],
            "href": "https://api.spotify.com/v1/artists/0L5fC7Ogm2YwgqVCRcF1bT",
            "id": "0L5fC7Ogm2YwgqVCRcF1bT",
            "images": [
                {
                    "height": 640,
                    "url": "https://i.scdn.co/image/ab6761610000e5eb50d73f9e78c8351bde9e7324",
                    "width": 640
                },
                {
                    "height": 320,
                    "url": "https://i.scdn.co/image/ab6761610000517450d73f9e78c8351bde9e7324",
                    "width": 320
                },
                {
                    "height": 160,
                    "url": "https://i.scdn.co/image/ab6761610000f17850d73f9e78c8351bde9e7324",
                    "width": 160
                }
            ],
            "name": "Volbeat",
            "popularity": 67,
            "type": "artist",
            "uri": "spotify:artist:0L5fC7Ogm2YwgqVCRcF1bT"
        },
        "0b2B3PwcYzQAhuJacmcYgc": {
            "external_urls": {
                "spotify": "https://open.spotify.com/artist/0b2B3PwcYzQAhuJacmcYgc"
            },
            "followers": {
                "href": null,
                "total": 865739
            },
            "genres": [
                "mongolian alternative",
                "oriental metal"
            ],
            "href": "https://api.spotify.com/v1/artists/0b2B3PwcYzQAhuJacmcYgc",
            "id": "0b2B3PwcYzQAhuJacmcYgc",
            "images": [
                {
                    "height": 640,
                    "url": "https://i.scdn.co/image/ab6761610000e5eb2ccdc24acf91ba14b1b2273a",
                    "width": 640
                },
                {
                    "height": 320,
                    "url": "https://i.scdn.co/image/ab676161000051742ccdc24acf91ba14b1b2273a",
                    "width": 320
                },
                {
                    "height": 160,
                    "url": "https://i.scdn.co/image/ab6761610000f1782ccdc24acf91ba14b1b2273a",
                    "width": 160
                }
            ],
            "name": "The HU",
            "popularity": 54,
            "type": "artist",
            "uri": "spotify:artist:0b2B3PwcYzQAhuJacmcYgc"
        },
        "21EqvfrgEecTOZtKffQ82k": {
            "external_urls": {
                "spotify": "https://open.spotify.com/artist/21EqvfrgEecTOZtKffQ82k"
            },
            "followers": {
                "href": null,
                "total": 2339
            },
            "genres": [],
            "href": "https://api.spotify.com/v1/artists/21EqvfrgEecTOZtKffQ82k",
            "id": "21EqvfrgEecTOZtKffQ82k",
            "images": [
                {
                    "height": 640,
                    "url": "https://i.scdn.co/image/ab6761610000e5eb631eae835f623c0efd0f4ffa",
                    "width": 640
                },
                {
                    "height": 320,
                    "url": "https://i.scdn.co/image/ab67616100005174631eae835f623c0efd0f4ffa",
                    "width": 320
                },
                {
                    "height": 160,
                    "url": "https://i.scdn.co/image/ab6761610000f178631eae835f623c0efd0f4ffa",
                    "width": 160
                }
            ],
            "name": "Tomi Ow\u00f3",
            "popularity": 27,
            "type": "artist",
            "uri": "spotify:artist:21EqvfrgEecTOZtKffQ82k"
        },
        "1r1uxoy19fzMxunt3ONAkG": {
            "external_urls": {
                "spotify": "https://open.spotify.com/artist/1r1uxoy19fzMxunt3ONAkG"
            },
            "followers": {
                "href": null,
                "total": 2387765
            },
            "genres": [
                "indie pop",
                "la indie",
                "pov: indie"
            ],
            "href": "https://api.spotify.com/v1/artists/1r1uxoy19fzMxunt3ONAkG",
            "id": "1r1uxoy19fzMxunt3ONAkG",
            "images": [
                {
                    "height": 640,
                    "url": "https://i.scdn.co/image/ab6761610000e5eb626686e362d30246e816cc5b",
                    "width": 640
                },
                {
                    "height": 320,
                    "url": "https://i.scdn.co/image/ab67616100005174626686e362d30246e816cc5b",
                    "width": 320
                },
                {
                    "height": 160,
                    "url": "https://i.scdn.co/image/ab6761610000f178626686e362d30246e816cc5b",
                    "width": 160
                }
            ],
            "name": "Phoebe Bridgers",
            "popularity": 75,
            "type": "artist",
            "uri": "spotify:artist:1r1uxoy19fzMxunt3ONAkG"
        },
        "5YGY8feqx7naU7z4HrwZM6": {
            "external_urls": {
                "spotify": "https://open.spotify.com/artist/5YGY8feqx7naU7z4HrwZM6"
            },
            "followers": {
                "href": null,
                "total": 24010157
            },
            "genres": [
                "pop"
            ],
            "href": "https://api.spotify.com/v1/artists/5YGY8feqx7naU7z4HrwZM6",
            "id": "5YGY8feqx7naU7z4HrwZM6",
            "images": [
                {
                    "height": 640,
                    "url": "https://i.scdn.co/image/ab6761610000e5ebb4ba86c361191d48cbeb4b32",
                    "width": 640
                },
                {
                    "height": 320,
                    "url": "https://i.scdn.co/image/ab67616100005174b4ba86c361191d48cbeb4b32",
                    "width": 320
                },
                {
                    "height": 160,
                    "url": "https://i.scdn.co/image/ab6761610000f178b4ba86c361191d48cbeb4b32",
                    "width": 160
                }
            ],
            "name": "Miley Cyrus",
            "popularity": 82,
            "type": "artist",
            "uri": "spotify:artist:5YGY8feqx7naU7z4HrwZM6"
        },
        "4olE3I5QU0dvSR7LIpqTXc": {
            "external_urls": {
                "spotify": "https://open.spotify.com/artist/4olE3I5QU0dvSR7LIpqTXc"
            },
            "followers": {
                "href": null,
                "total": 22607
            },
            "genres": [
                "modern alternative rock"
            ],
            "href": "https://api.spotify.com/v1/artists/4olE3I5QU0dvSR7LIpqTXc",
            "id": "4olE3I5QU0dvSR7LIpqTXc",
            "images": [
                {
                    "height": 640,
                    "url": "https://i.scdn.co/image/ab6761610000e5eb0bd101b7d708edeb1c915452",
                    "width": 640
                },
                {
                    "height": 320,
                    "url": "https://i.scdn.co/image/ab676161000051740bd101b7d708edeb1c915452",
                    "width": 320
                },
                {
                    "height": 160,
                    "url": "https://i.scdn.co/image/ab6761610000f1780bd101b7d708edeb1c915452",
                    "width": 160
                }
            ],
            "name": "WATT",
            "popularity": 56,
            "type": "artist",
            "uri": "spotify:artist:4olE3I5QU0dvSR7LIpqTXc"
        },
        "3PhoLpVuITZKcymswpck5b": {
            "external_urls": {
                "spotify": "https://open.spotify.com/artist/3PhoLpVuITZKcymswpck5b"
            },
            "followers": {
                "href": null,
                "total": 13294772
            },
            "genres": [
                "glam rock",
                "mellow gold",
                "piano rock",
                "rock"
            ],
            "href": "https://api.spotify.com/v1/artists/3PhoLpVuITZKcymswpck5b",
            "id": "3PhoLpVuITZKcymswpck5b",
            "images": [
                {
                    "height": 640,
                    "url": "https://i.scdn.co/image/ab6761610000e5eb0a7388b95df960b5c0da8970",
                    "width": 640
                },
                {
                    "height": 320,
                    "url": "https://i.scdn.co/image/ab676161000051740a7388b95df960b5c0da8970",
                    "width": 320
                },
                {
                    "height": 160,
                    "url": "https://i.scdn.co/image/ab6761610000f1780a7388b95df960b5c0da8970",
                    "width": 160
                }
            ],
            "name": "Elton John",
            "popularity": 81,
            "type": "artist",
            "uri": "spotify:artist:3PhoLpVuITZKcymswpck5b"
        },
        "5Dl3HXZjG6ZOWT5cV375lk": {
            "external_urls": {
                "spotify": "https://open.spotify.com/artist/5Dl3HXZjG6ZOWT5cV375lk"
            },
            "followers": {
                "href": null,
                "total": 595692
            },
            "genres": [
                "chamber ensemble",
                "classical cello",
                "classical performance"
            ],
            "href": "https://api.spotify.com/v1/artists/5Dl3HXZjG6ZOWT5cV375lk",
            "id": "5Dl3HXZjG6ZOWT5cV375lk",
            "images": [
                {
                    "height": 640,
                    "url": "https://i.scdn.co/image/ab6761610000e5ebfb0fcd51414e7bbe85e00b6f",
                    "width": 640
                },
                {
                    "height": 320,
                    "url": "https://i.scdn.co/image/ab67616100005174fb0fcd51414e7bbe85e00b6f",
                    "width": 320
                },
                {
                    "height": 160,
                    "url": "https://i.scdn.co/image/ab6761610000f178fb0fcd51414e7bbe85e00b6f",
                    "width": 160
                }
            ],
            "name": "Yo-Yo Ma",
            "popularity": 63,
            "type": "artist",
            "uri": "spotify:artist:5Dl3HXZjG6ZOWT5cV375lk"
        },
        "3rROvEsUJJ9y55g1PLaA16": {
            "external_urls": {
                "spotify": "https://open.spotify.com/artist/3rROvEsUJJ9y55g1PLaA16"
            },
            "followers": {
                "href": null,
                "total": 7324
            },
            "genres": [],
            "href": "https://api.spotify.com/v1/artists/3rROvEsUJJ9y55g1PLaA16",
            "id": "3rROvEsUJJ9y55g1PLaA16",
            "images": [
                {
                    "height": 640,
                    "url": "https://i.scdn.co/image/ab6761610000e5eb88c4ea3e867352dc49ed9990",
                    "width": 640
                },
                {
                    "height": 320,
                    "url": "https://i.scdn.co/image/ab6761610000517488c4ea3e867352dc49ed9990",
                    "width": 320
                },
                {
                    "height": 160,
                    "url": "https://i.scdn.co/image/ab6761610000f17888c4ea3e867352dc49ed9990",
                    "width": 160
                }
            ],
            "name": "Robert Trujillo",
            "popularity": 43,
            "type": "artist",
            "uri": "spotify:artist:3rROvEsUJJ9y55g1PLaA16"
        },
        "4DW34vji6G9GgGY0k2mic7": {
            "external_urls": {
                "spotify": "https://open.spotify.com/artist/4DW34vji6G9GgGY0k2mic7"
            },
            "followers": {
                "href": null,
                "total": 4569
            },
            "genres": [
                "rock drums"
            ],
            "href": "https://api.spotify.com/v1/artists/4DW34vji6G9GgGY0k2mic7",
            "id": "4DW34vji6G9GgGY0k2mic7",
            "images": [
                {
                    "height": 405,
                    "url": "https://i.scdn.co/image/894c20ff4cd06d43481fe9dfd23d3c4a20ed8cc3",
                    "width": 1000
                },
                {
                    "height": 259,
                    "url": "https://i.scdn.co/image/843532df7514524476dddf5d181f64afdd812022",
                    "width": 639
                },
                {
                    "height": 81,
                    "url": "https://i.scdn.co/image/c772ab4332a379a96842c8879fcfb92a229d93a6",
                    "width": 200
                },
                {
                    "height": 26,
                    "url": "https://i.scdn.co/image/c4357fca783ab7494b1b52ba5edbf59cfccc2b69",
                    "width": 64
                }
            ],
            "name": "Chad Smith",
            "popularity": 42,
            "type": "artist",
            "uri": "spotify:artist:4DW34vji6G9GgGY0k2mic7"
        },
        "7hKXTmrq3ZppBx881yBbOr": {
            "external_urls": {
                "spotify": "https://open.spotify.com/artist/7hKXTmrq3ZppBx881yBbOr"
            },
            "followers": {
                "href": null,
                "total": 215501
            },
            "genres": [
                "alternative dance"
            ],
            "href": "https://api.spotify.com/v1/artists/7hKXTmrq3ZppBx881yBbOr",
            "id": "7hKXTmrq3ZppBx881yBbOr",
            "images": [
                {
                    "height": 640,
                    "url": "https://i.scdn.co/image/ab6761610000e5ebe0c36cc7f070ba1e9e3ec598",
                    "width": 640
                },
                {
                    "height": 320,
                    "url": "https://i.scdn.co/image/ab67616100005174e0c36cc7f070ba1e9e3ec598",
                    "width": 320
                },
                {
                    "height": 160,
                    "url": "https://i.scdn.co/image/ab6761610000f178e0c36cc7f070ba1e9e3ec598",
                    "width": 160
                }
            ],
            "name": "Dave Gahan",
            "popularity": 37,
            "type": "artist",
            "uri": "spotify:artist:7hKXTmrq3ZppBx881yBbOr"
        },
        "6nfN5B7Jmi853SHa9106Hz": {
            "external_urls": {
                "spotify": "https://open.spotify.com/artist/6nfN5B7Jmi853SHa9106Hz"
            },
            "followers": {
                "href": null,
                "total": 93514
            },
            "genres": [
                "black americana",
                "contemporary country",
                "country pop"
            ],
            "href": "https://api.spotify.com/v1/artists/6nfN5B7Jmi853SHa9106Hz",
            "id": "6nfN5B7Jmi853SHa9106Hz",
            "images": [
                {
                    "height": 640,
                    "url": "https://i.scdn.co/image/ab6761610000e5eb9dcf643ba343be26ea263251",
                    "width": 640
                },
                {
                    "height": 320,
                    "url": "https://i.scdn.co/image/ab676161000051749dcf643ba343be26ea263251",
                    "width": 320
                },
                {
                    "height": 160,
                    "url": "https://i.scdn.co/image/ab6761610000f1789dcf643ba343be26ea263251",
                    "width": 160
                }
            ],
            "name": "Mickey Guyton",
            "popularity": 45,
            "type": "artist",
            "uri": "spotify:artist:6nfN5B7Jmi853SHa9106Hz"
        },
        "5KNNVgR6LBIABRIomyCwKJ": {
            "external_urls": {
                "spotify": "https://open.spotify.com/artist/5KNNVgR6LBIABRIomyCwKJ"
            },
            "followers": {
                "href": null,
                "total": 1537476
            },
            "genres": [
                "folk-pop",
                "irish pop",
                "uk pop"
            ],
            "href": "https://api.spotify.com/v1/artists/5KNNVgR6LBIABRIomyCwKJ",
            "id": "5KNNVgR6LBIABRIomyCwKJ",
            "images": [
                {
                    "height": 640,
                    "url": "https://i.scdn.co/image/ab6761610000e5eb01d2c1d798d01d814a830430",
                    "width": 640
                },
                {
                    "height": 320,
                    "url": "https://i.scdn.co/image/ab6761610000517401d2c1d798d01d814a830430",
                    "width": 320
                },
                {
                    "height": 160,
                    "url": "https://i.scdn.co/image/ab6761610000f17801d2c1d798d01d814a830430",
                    "width": 160
                }
            ],
            "name": "Dermot Kennedy",
            "popularity": 68,
            "type": "artist",
            "uri": "spotify:artist:5KNNVgR6LBIABRIomyCwKJ"
        },
        "4boI7bJtmB1L3b1cuL75Zr": {
            "external_urls": {
                "spotify": "https://open.spotify.com/artist/4boI7bJtmB1L3b1cuL75Zr"
            },
            "followers": {
                "href": null,
                "total": 7006145
            },
            "genres": [
                "latin alternative"
            ],
            "href": "https://api.spotify.com/v1/artists/4boI7bJtmB1L3b1cuL75Zr",
            "id": "4boI7bJtmB1L3b1cuL75Zr",
            "images": [
                {
                    "height": 640,
                    "url": "https://i.scdn.co/image/ab6761610000e5eb2a89a5ad55e1cb241440afef",
                    "width": 640
                },
                {
                    "height": 320,
                    "url": "https://i.scdn.co/image/ab676161000051742a89a5ad55e1cb241440afef",
                    "width": 320
                },
                {
                    "height": 160,
                    "url": "https://i.scdn.co/image/ab6761610000f1782a89a5ad55e1cb241440afef",
                    "width": 160
                }
            ],
            "name": "Mon Laferte",
            "popularity": 72,
            "type": "artist",
            "uri": "spotify:artist:4boI7bJtmB1L3b1cuL75Zr"
        },
        "0japPUWMmW3gxqjSB1VEVL": {
            "external_urls": {
                "spotify": "https://open.spotify.com/artist/0japPUWMmW3gxqjSB1VEVL"
            },
            "followers": {
                "href": null,
                "total": 51134
            },
            "genres": [
                "classical piano",
                "russian classical piano"
            ],
            "href": "https://api.spotify.com/v1/artists/0japPUWMmW3gxqjSB1VEVL",
            "id": "0japPUWMmW3gxqjSB1VEVL",
            "images": [
                {
                    "height": 640,
                    "url": "https://i.scdn.co/image/ab6761610000e5ebb73d9e5ace360251d37ee688",
                    "width": 640
                },
                {
                    "height": 320,
                    "url": "https://i.scdn.co/image/ab67616100005174b73d9e5ace360251d37ee688",
                    "width": 320
                },
                {
                    "height": 160,
                    "url": "https://i.scdn.co/image/ab6761610000f178b73d9e5ace360251d37ee688",
                    "width": 160
                }
            ],
            "name": "Igor Levit",
            "popularity": 49,
            "type": "artist",
            "uri": "spotify:artist:0japPUWMmW3gxqjSB1VEVL"
        },
        "43O3c6wewpzPKwVaGEEtBM": {
            "external_urls": {
                "spotify": "https://open.spotify.com/artist/43O3c6wewpzPKwVaGEEtBM"
            },
            "followers": {
                "href": null,
                "total": 545843
            },
            "genres": [
                "chamber pop",
                "indie rock",
                "jam band",
                "louisville indie",
                "melancholia",
                "roots rock",
                "stomp and holler"
            ],
            "href": "https://api.spotify.com/v1/artists/43O3c6wewpzPKwVaGEEtBM",
            "id": "43O3c6wewpzPKwVaGEEtBM",
            "images": [
                {
                    "height": 640,
                    "url": "https://i.scdn.co/image/ab6761610000e5eb236c35f5215954e1f9a2f1c6",
                    "width": 640
                },
                {
                    "height": 320,
                    "url": "https://i.scdn.co/image/ab67616100005174236c35f5215954e1f9a2f1c6",
                    "width": 320
                },
                {
                    "height": 160,
                    "url": "https://i.scdn.co/image/ab6761610000f178236c35f5215954e1f9a2f1c6",
                    "width": 160
                }
            ],
            "name": "My Morning Jacket",
            "popularity": 50,
            "type": "artist",
            "uri": "spotify:artist:43O3c6wewpzPKwVaGEEtBM"
        },
        "3k87PFuum7Sv7zzjw7BMIg": {
            "external_urls": {
                "spotify": "https://open.spotify.com/artist/3k87PFuum7Sv7zzjw7BMIg"
            },
            "followers": {
                "href": null,
                "total": 8000
            },
            "genres": [],
            "href": "https://api.spotify.com/v1/artists/3k87PFuum7Sv7zzjw7BMIg",
            "id": "3k87PFuum7Sv7zzjw7BMIg",
            "images": [
                {
                    "height": 640,
                    "url": "https://i.scdn.co/image/ab6761610000e5ebc37d08000973f53edf170bbf",
                    "width": 640
                },
                {
                    "height": 320,
                    "url": "https://i.scdn.co/image/ab67616100005174c37d08000973f53edf170bbf",
                    "width": 320
                },
                {
                    "height": 160,
                    "url": "https://i.scdn.co/image/ab6761610000f178c37d08000973f53edf170bbf",
                    "width": 160
                }
            ],
            "name": "PG Roxette",
            "popularity": 32,
            "type": "artist",
            "uri": "spotify:artist:3k87PFuum7Sv7zzjw7BMIg"
        },
        "7FY5V3XMwlNBPitEjXowHQ": {
            "external_urls": {
                "spotify": "https://open.spotify.com/artist/7FY5V3XMwlNBPitEjXowHQ"
            },
            "followers": {
                "href": null,
                "total": 2556309
            },
            "genres": [
                "black americana",
                "contemporary country",
                "country",
                "country road",
                "modern country rock"
            ],
            "href": "https://api.spotify.com/v1/artists/7FY5V3XMwlNBPitEjXowHQ",
            "id": "7FY5V3XMwlNBPitEjXowHQ",
            "images": [
                {
                    "height": 640,
                    "url": "https://i.scdn.co/image/ab6761610000e5eb17f1bb8128fc6e637e4240d7",
                    "width": 640
                },
                {
                    "height": 320,
                    "url": "https://i.scdn.co/image/ab6761610000517417f1bb8128fc6e637e4240d7",
                    "width": 320
                },
                {
                    "height": 160,
                    "url": "https://i.scdn.co/image/ab6761610000f17817f1bb8128fc6e637e4240d7",
                    "width": 160
                }
            ],
            "name": "Darius Rucker",
            "popularity": 65,
            "type": "artist",
            "uri": "spotify:artist:7FY5V3XMwlNBPitEjXowHQ"
        },
        "4YLtscXsxbVgi031ovDDdh": {
            "external_urls": {
                "spotify": "https://open.spotify.com/artist/4YLtscXsxbVgi031ovDDdh"
            },
            "followers": {
                "href": null,
                "total": 7048602
            },
            "genres": [
                "contemporary country",
                "outlaw country"
            ],
            "href": "https://api.spotify.com/v1/artists/4YLtscXsxbVgi031ovDDdh",
            "id": "4YLtscXsxbVgi031ovDDdh",
            "images": [
                {
                    "height": 640,
                    "url": "https://i.scdn.co/image/ab6761610000e5eba0c87c8f329b436eac8b9784",
                    "width": 640
                },
                {
                    "height": 320,
                    "url": "https://i.scdn.co/image/ab67616100005174a0c87c8f329b436eac8b9784",
                    "width": 320
                },
                {
                    "height": 160,
                    "url": "https://i.scdn.co/image/ab6761610000f178a0c87c8f329b436eac8b9784",
                    "width": 160
                }
            ],
            "name": "Chris Stapleton",
            "popularity": 80,
            "type": "artist",
            "uri": "spotify:artist:4YLtscXsxbVgi031ovDDdh"
        },
        "5tYaRVYbV1anmzyxqMVdHi": {
            "external_urls": {
                "spotify": "https://open.spotify.com/artist/5tYaRVYbV1anmzyxqMVdHi"
            },
            "followers": {
                "href": null,
                "total": 34951
            },
            "genres": [
                "south african pop",
                "south african pop dance"
            ],
            "href": "https://api.spotify.com/v1/artists/5tYaRVYbV1anmzyxqMVdHi",
            "id": "5tYaRVYbV1anmzyxqMVdHi",
            "images": [
                {
                    "height": 640,
                    "url": "https://i.scdn.co/image/ab6761610000e5eb4f6f3e52105bcde281f7caca",
                    "width": 640
                },
                {
                    "height": 320,
                    "url": "https://i.scdn.co/image/ab676161000051744f6f3e52105bcde281f7caca",
                    "width": 320
                },
                {
                    "height": 160,
                    "url": "https://i.scdn.co/image/ab6761610000f1784f6f3e52105bcde281f7caca",
                    "width": 160
                }
            ],
            "name": "TRESOR",
            "popularity": 36,
            "type": "artist",
            "uri": "spotify:artist:5tYaRVYbV1anmzyxqMVdHi"
        },
        "5ammRFhN6wQXM30xlhndC5": {
            "external_urls": {
                "spotify": "https://open.spotify.com/artist/5ammRFhN6wQXM30xlhndC5"
            },
            "followers": {
                "href": null,
                "total": 52201
            },
            "genres": [
                "rebel blues"
            ],
            "href": "https://api.spotify.com/v1/artists/5ammRFhN6wQXM30xlhndC5",
            "id": "5ammRFhN6wQXM30xlhndC5",
            "images": [
                {
                    "height": 640,
                    "url": "https://i.scdn.co/image/ab6761610000e5eb688262afc64a9b58f08bf97f",
                    "width": 640
                },
                {
                    "height": 320,
                    "url": "https://i.scdn.co/image/ab67616100005174688262afc64a9b58f08bf97f",
                    "width": 320
                },
                {
                    "height": 160,
                    "url": "https://i.scdn.co/image/ab6761610000f178688262afc64a9b58f08bf97f",
                    "width": 160
                }
            ],
            "name": "Goodnight, Texas",
            "popularity": 46,
            "type": "artist",
            "uri": "spotify:artist:5ammRFhN6wQXM30xlhndC5"
        },
        "75mafsNqNE1WSEVxIKuY5C": {
            "external_urls": {
                "spotify": "https://open.spotify.com/artist/75mafsNqNE1WSEVxIKuY5C"
            },
            "followers": {
                "href": null,
                "total": 680889
            },
            "genres": [
                "bristol indie",
                "crank wave",
                "indie rock",
                "modern rock"
            ],
            "href": "https://api.spotify.com/v1/artists/75mafsNqNE1WSEVxIKuY5C",
            "id": "75mafsNqNE1WSEVxIKuY5C",
            "images": [
                {
                    "height": 640,
                    "url": "https://i.scdn.co/image/ab6761610000e5ebd432d36ca35d0b7a6bf82cef",
                    "width": 640
                },
                {
                    "height": 320,
                    "url": "https://i.scdn.co/image/ab67616100005174d432d36ca35d0b7a6bf82cef",
                    "width": 320
                },
                {
                    "height": 160,
                    "url": "https://i.scdn.co/image/ab6761610000f178d432d36ca35d0b7a6bf82cef",
                    "width": 160
                }
            ],
            "name": "IDLES",
            "popularity": 59,
            "type": "artist",
            "uri": "spotify:artist:75mafsNqNE1WSEVxIKuY5C"
        },
        "6AnjHMqEAps8VJdHU8RykH": {
            "external_urls": {
                "spotify": "https://open.spotify.com/artist/6AnjHMqEAps8VJdHU8RykH"
            },
            "followers": {
                "href": null,
                "total": 174853
            },
            "genres": [
                "neo-rockabilly",
                "rockabilly"
            ],
            "href": "https://api.spotify.com/v1/artists/6AnjHMqEAps8VJdHU8RykH",
            "id": "6AnjHMqEAps8VJdHU8RykH",
            "images": [
                {
                    "height": 640,
                    "url": "https://i.scdn.co/image/ab6761610000e5eb05e7fbb041780e87e8a625d2",
                    "width": 640
                },
                {
                    "height": 320,
                    "url": "https://i.scdn.co/image/ab6761610000517405e7fbb041780e87e8a625d2",
                    "width": 320
                },
                {
                    "height": 160,
                    "url": "https://i.scdn.co/image/ab6761610000f17805e7fbb041780e87e8a625d2",
                    "width": 160
                }
            ],
            "name": "Imelda May",
            "popularity": 43,
            "type": "artist",
            "uri": "spotify:artist:6AnjHMqEAps8VJdHU8RykH"
        },
        "3pIGm1omCcHIb1juBNHspg": {
            "external_urls": {
                "spotify": "https://open.spotify.com/artist/3pIGm1omCcHIb1juBNHspg"
            },
            "followers": {
                "href": null,
                "total": 166664
            },
            "genres": [
                "bubblegrunge",
                "indie punk",
                "indie surf",
                "la indie"
            ],
            "href": "https://api.spotify.com/v1/artists/3pIGm1omCcHIb1juBNHspg",
            "id": "3pIGm1omCcHIb1juBNHspg",
            "images": [
                {
                    "height": 640,
                    "url": "https://i.scdn.co/image/ab6761610000e5ebbe4108c674ad29f8440c67d2",
                    "width": 640
                },
                {
                    "height": 320,
                    "url": "https://i.scdn.co/image/ab67616100005174be4108c674ad29f8440c67d2",
                    "width": 320
                },
                {
                    "height": 160,
                    "url": "https://i.scdn.co/image/ab6761610000f178be4108c674ad29f8440c67d2",
                    "width": 160
                }
            ],
            "name": "Cherry Glazerr",
            "popularity": 41,
            "type": "artist",
            "uri": "spotify:artist:3pIGm1omCcHIb1juBNHspg"
        },
        "6T08mUIMB32dtqq5ryxQZ3": {
            "external_urls": {
                "spotify": "https://open.spotify.com/artist/6T08mUIMB32dtqq5ryxQZ3"
            },
            "followers": {
                "href": null,
                "total": 97590
            },
            "genres": [
                "french indie pop",
                "french pop",
                "french rock",
                "nouvelle chanson francaise"
            ],
            "href": "https://api.spotify.com/v1/artists/6T08mUIMB32dtqq5ryxQZ3",
            "id": "6T08mUIMB32dtqq5ryxQZ3",
            "images": [
                {
                    "height": 640,
                    "url": "https://i.scdn.co/image/ab6761610000e5ebb298576bc0bdf9ae3fd5f775",
                    "width": 640
                },
                {
                    "height": 320,
                    "url": "https://i.scdn.co/image/ab67616100005174b298576bc0bdf9ae3fd5f775",
                    "width": 320
                },
                {
                    "height": 160,
                    "url": "https://i.scdn.co/image/ab6761610000f178b298576bc0bdf9ae3fd5f775",
                    "width": 160
                }
            ],
            "name": "Iz\u00efa",
            "popularity": 45,
            "type": "artist",
            "uri": "spotify:artist:6T08mUIMB32dtqq5ryxQZ3"
        },
        "6HQYnRM4OzToCYPpVBInuU": {
            "external_urls": {
                "spotify": "https://open.spotify.com/artist/6HQYnRM4OzToCYPpVBInuU"
            },
            "followers": {
                "href": null,
                "total": 465232
            },
            "genres": [
                "afrofuturism",
                "contemporary jazz",
                "indie soul",
                "jazz",
                "jazz saxophone"
            ],
            "href": "https://api.spotify.com/v1/artists/6HQYnRM4OzToCYPpVBInuU",
            "id": "6HQYnRM4OzToCYPpVBInuU",
            "images": [
                {
                    "height": 640,
                    "url": "https://i.scdn.co/image/ab6761610000e5ebefa4712d1cdf27fd2869a396",
                    "width": 640
                },
                {
                    "height": 320,
                    "url": "https://i.scdn.co/image/ab67616100005174efa4712d1cdf27fd2869a396",
                    "width": 320
                },
                {
                    "height": 160,
                    "url": "https://i.scdn.co/image/ab6761610000f178efa4712d1cdf27fd2869a396",
                    "width": 160
                }
            ],
            "name": "Kamasi Washington",
            "popularity": 54,
            "type": "artist",
            "uri": "spotify:artist:6HQYnRM4OzToCYPpVBInuU"
        },
        "7vX3cMVyW8gtDA4y855ynF": {
            "external_urls": {
                "spotify": "https://open.spotify.com/artist/7vX3cMVyW8gtDA4y855ynF"
            },
            "followers": {
                "href": null,
                "total": 436044
            },
            "genres": [
                "acoustic rock",
                "world"
            ],
            "href": "https://api.spotify.com/v1/artists/7vX3cMVyW8gtDA4y855ynF",
            "id": "7vX3cMVyW8gtDA4y855ynF",
            "images": [
                {
                    "height": 640,
                    "url": "https://i.scdn.co/image/ab6761610000e5ebaf824664934f599fa2601a40",
                    "width": 640
                },
                {
                    "height": 320,
                    "url": "https://i.scdn.co/image/ab67616100005174af824664934f599fa2601a40",
                    "width": 320
                },
                {
                    "height": 160,
                    "url": "https://i.scdn.co/image/ab6761610000f178af824664934f599fa2601a40",
                    "width": 160
                }
            ],
            "name": "Rodrigo y Gabriela",
            "popularity": 47,
            "type": "artist",
            "uri": "spotify:artist:7vX3cMVyW8gtDA4y855ynF"
        }
    }
) 